import { useState } from "react";
import { CHARTS } from "@modules/financialplan/constants";
import ProjectedFinancialPlanAreaChart from "@modules/financialplan/components/ProjectedFinancialPlanAreaChart";
import GoalTimelineStackedBarChart from "@modules/financialplan/components/GoalTimelineStackedBarChart";
import { HiOutlineChevronDown } from "react-icons/hi";
import useStore from "@modules/financialplan/state";
import PlanScenarioToggleSwitch from "../PlanScenarioToggleSwitch";
import { Typography } from "@earned/core";
import { themeTextColors } from "@common/constants";

const FinancialPlanCharts = () => {
  const { selectedScenario } = useStore();
  const [currentChart, setCurrentChart] = useState<string>(
    CHARTS.PROJECTED_FINANCIAL_PLAN
  );
  const onClickDropdownMenu = () => {
    // toggle as placeholder until i refactor popover menu
    if (currentChart === CHARTS.PROJECTED_FINANCIAL_PLAN) {
      setCurrentChart(CHARTS.GOAL_TIMELINE);
    } else {
      setCurrentChart(CHARTS.PROJECTED_FINANCIAL_PLAN);
    }
  };

  return (
    <div
      className={
        "p-10 transition-all " +
        (currentChart === CHARTS.PROJECTED_FINANCIAL_PLAN
          ? "h-[448px]"
          : "h-[448px]")
      }
    >
      <div className="flex flex-row items-start justify-between">
        <button
          onClick={onClickDropdownMenu}
          className="mb-3 flex flex-row items-start"
        >
          <div className="mr-4 text-left">
            <Typography variant="body" weight="medium">
              {currentChart === CHARTS.PROJECTED_FINANCIAL_PLAN &&
                "Projected Financial Plan"}
              {currentChart === CHARTS.GOAL_TIMELINE &&
                "Goal Expenses Timeline"}
            </Typography>
            {currentChart === CHARTS.PROJECTED_FINANCIAL_PLAN ? (
              <div className="flex flex-col">
                <Typography color="primary" variant="body-sm">
                  Current Dollars
                </Typography>
                <Typography variant="body-xs" color="secondary">
                  An approximation from the projected future value
                </Typography>
              </div>
            ) : (
              <Typography color="primary" variant="body-sm">
                Current Dollars
              </Typography>
            )}
          </div>
          <div className="mt-0.5">
            <HiOutlineChevronDown color={themeTextColors.primary} size={24} />
          </div>
        </button>
        {currentChart === CHARTS.GOAL_TIMELINE && <PlanScenarioToggleSwitch />}
      </div>
      <div className="flex h-full flex-1">
        {currentChart === CHARTS.PROJECTED_FINANCIAL_PLAN && (
          <div className="flex h-[300px] flex-1">
            <ProjectedFinancialPlanAreaChart />
          </div>
        )}
        {currentChart === CHARTS.GOAL_TIMELINE && (
          <GoalTimelineStackedBarChart scenario={selectedScenario} />
        )}
      </div>
    </div>
  );
};

export default FinancialPlanCharts;
